export default __webpack_public_path__ + "static/media/information-circle.85284ff2.svg";